<template>
  <div class="w w1200 storeCert">
    <div class="store-info-card">
      <shopStoreItem :shopInfo='storeData' :isshow="0"></shopStoreItem>
    </div>
    <div class="store-cert-list bg-white border">
      <div class="bg-gray p-10 fw-500">网店经营者资质信息公示</div>
      <div class="store-cert-img p-20">
        <el-divider class="fz-16 fw-500" content-position="left">腾信智慧商城网店经营者营业执照信息</el-divider>
        <el-form :model="storeData" class="form" label-width="120px" v-if="storeData">
          <el-form-item label="公司名称">{{storeData.companyName}}</el-form-item>
          <el-form-item label="公司地址">{{storeData.companyLocationName}}{{storeData.address}}</el-form-item>
          <el-form-item label="公司电话">{{storeData.phone}}</el-form-item>
          <el-form-item label="联系人">{{storeData.contactPerson}}</el-form-item>
          <el-form-item label="联系人电话">{{storeData.emergencyManCall | phoneEncryption}}</el-form-item>
          <el-form-item label="联系人邮箱">{{storeData.emergencyManEmail}}</el-form-item>
          <el-form-item label="纳税人识别号">{{storeData.taxpayerNumber}}</el-form-item>
          <el-form-item label="发票抬头">{{storeData.invoice}}</el-form-item>
<!--          <el-form-item label="营业执照">-->
<!--            <el-image class="image" :src="storeData.businessLicense" :preview-src-list="[storeData.businessLicense]" fit="contain"></el-image>-->
<!--          </el-form-item>-->
          <el-form-item label="店铺名称">{{storeData.name}}</el-form-item>
          <el-form-item label="店铺等级">{{storeData.levelName}}</el-form-item>
          <el-form-item label="店铺分类">{{storeData.merchantSortName}}</el-form-item>
          <el-form-item label="经营类目">{{storeData.types}}</el-form-item>
        </el-form>
        <el-divider class="fz-16 fw-500" content-position="left">腾信智慧商城网店经营者资质信息</el-divider>
        <p class="p-v-10">根据国家相关政策要求对网店经营者资质信息公示如下：</p>
        <div class="img-box">
          <div class="img-marker">
            <div class="marker-item"
                  v-for="item in 30"
                  :key="`businessLicense_${item}`">仅供腾信智慧商城入驻使用</div>
          </div>
          <img class="img-style" :src="storeData.businessLicense" alt="营业执照" v-if="storeData.businessLicense">
        </div>
        <div class="img-box"
             v-for="url in extImg" :key="url">
          <div class="img-marker">
            <div class="marker-item"
                 v-for="item in 30"
                 :key="`${url}_${item}`">仅供腾信智慧商城入驻使用</div>
          </div>
          <img class="img-style" :src="url" alt="" >
        </div>

        <div class="fz-12 p-v-10 text-gray">
          注：以上信息，由商家依据《电子商务法》规定发布公示。 如需进一步核实，可联系商家客服咨询。
        </div>
      </div>
    </div>
  </div>
</template>

<script type="application/javascript">
import {storeInfo, storeList} from "@/api/xunyou";
import ShopStoreItem from '@/components/shopStoreItem';
export default {
  name: "storeCert",
  components: {
    ShopStoreItem
  },
  data() {
    return {
      loading: false,
      storeData:  {
        "searchValue": null,
        "createBy": "",
        "createTime": "2021-03-25 13:46:44",
        "updateBy": "",
        "updateTime": "2021-03-25 13:47:03",
        "remark": "",
        "pageDefStart": 0,
        "pageDefSize": 0,
        "params": {},
        "bxmId": 13,
        "name": "红谷旗舰店",
        "sellerAccount": "13917195771",
        "imUserId": null,
        "logo": null,
        "type": 2,
        "power": 1,
        "status": 2,
        "sort": 3,
        "sortname": "普通商户",
        "isSelfEmployed": 1,
        "orderNum": null,
        "level": 1,
        "levelName": "普通店铺",
        "mainproduct": "手机/品牌机/传呼机/充电器/yang",
        "cycle": null,
        "validPeriod": null,
        "companyName": "红谷旗舰店",
        "companyLocation": "上海市/上海市/闵行区",
        "companyLocationName": null,
        "address": "T3",
        "postalCode": "",
        "phone": "",
        "companyUrl": "",
        "companyProfile": "",
        "contactPerson": "CC",
        "position": "",
        "emergencyManCall": "13917195771",
        "emergencyManEmail": "",
        "registeredCapital": "",
        "staffNum": null,
        "taxpayerNumber": "",
        "invoice": "",
        "businessLicense": "https://img30.360buyimg.com/popshop/jfs/t1/176367/24/28281/496942/6205ca26E0163eaa3/f25b0216c2499833.jpg",
        "payForImg": null,
        "isdel": 0,
        "goods": null,
        "checked": false,
        "isCollect": 0,
        "userId": null,
        "footprint_num": 0,
        "qq": null,
        "banner_pc": null,
        "banner_app": null,
        "wx": null,
        "recommendMuid": 223,
        "recommendUserPhone": null,
        "payforimg": null,
        "bannerPc": null,
        "bannerApp": null,
        "marginNeedAmount": 0.00,
        "marginPaidAmount": 0.00,
        "marginRefundAmount": 0.00,
        "alreadyDistributeGoods": null,
        "settRateReal": 0.00,
        "settRateVirtual": 0.00,
        "settRateServer": 0.00,
        "settRateOffline": 0.00,
        "saleStatus": "1",
        "auditMemo": null,
        "extImg": "https://img30.360buyimg.com/popshop/jfs/t1/200529/36/30789/107233/63be8639F88243ce6/628ac2b005f66cf6.jpg,https://img30.360buyimg.com/popshop/jfs/t1/205009/26/10656/197463/6166b589E762f0a56/e0c8ede1e8b37dbd.jpg",
        "shutStatus": "NONE",
        "shutMemo": null
      }
    };
  },
  computed: {
    storeId() {
      return this.$route.query.storeId;
    },
    userId() {
      return this.$store.getters.userId;
    },
    extImg() {
      try {
        return this.storeData.extImg.split(',');
      } catch (e) {
        return [];
      }
    }
  },
  created() {
    this.getStoreInfo();
  },
  mounted() {
  },
  methods: {
    getStoreInfo() {
      this.loading = true;
      storeInfo({
        bxmId: this.storeId,
      }).then((res) => {
        console.log('店铺信息：', res);
        this.loading = false;
        if (res.code === 0) {
          this.storeData = res.data;
        }
      }).catch((err) => {
        this.loading = false;
        this.$message.error("店铺查询失败，请稍后再试！");
      });
    },
  }
}
</script>

<style lang="less" scoped>
.storeCert{
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  color: #666666;
  .store-info-card{
    width: 232px;
    margin-left: -3px;
    margin-right: 10px;
  }
  .store-cert-list{
    flex: 1;
  }
}
/deep/ .el-form-item{
  margin-bottom: 0;
}
/deep/ .el-form-item__label{
  font-weight: bold;
}
.text-gray{
  color: #C1C1C1;
}
.img-style{
  width: 100%;
  height: auto;
}
.flex-x-start{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.border{
  border: solid 1px #ddd;
}
.bg-white{
  background-color: #fff;
}
.bg-gray{
  background: -webkit-gradient(linear, 0 0, 0 bottom, from(#ffffff), to(#f3f3f3));
}
.fz-12{
  font-size: 12px;
}
.fz-16{
  font-size: 16px;
}
.fw-500{
  font-weight: 500;
}
.m-t-10{
  margin-top: 10px;
}
.w-200{
  width: 200px;
}
.p-10{
  padding: 10px;
}
.p-v-10{
  padding: 10px 0;
}
.p-h-10{
  padding: 0 10px;
}
.p-20{
  padding: 20px;
}
.p-v-20{
  padding: 20px 0;
}
.p-h-20{
  padding: 0 20px;
}
.p-30{
  padding: 30px;
}
.p-v-30{
  padding: 30px 0;
}
.p-h-30{
  padding: 0 30px;
}
.img-box{
  position: relative;
  .img-marker{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    overflow: hidden;
    .marker-item{
      display: inline-block;
      font-weight: bold;
      font-size: 18px;
      opacity: 0.3;
      margin: 60px 10px;
      transform: rotate(-30deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/store/storeCert.vue